import {
    Component,
    EventEmitter,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { filter, lastValueFrom, Subject, takeUntil } from 'rxjs';
import { FamilyAccessComponent } from 'src/app/modals/family-access/family-access.component';
import { HttpNewService } from 'src/app/services/application/http-new.service';
import { CookieConsentService } from 'src/app/services/cookie-consent/cookie-consent-service';
import { Store } from 'src/app/services/store.service';
import { IPatient } from '../../../interfaces/patient.interfaces';
import { FeedbackModalComponent } from '../../../modals/feedback/feedback.component';
import { StatementComponent } from '../../../modals/statement/statement.component';
import { LoadService } from '../../../services/application/load.service';
import { AuthService } from '../../../services/auth.service';
import { PatientService } from '../../../services/patient.service';
import { Size } from '../../../services/size';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false,
})
export class HeaderComponent implements OnInit, OnDestroy {
    @Output() public patientNameChange = new EventEmitter<string>();
    public btnDropUP = false; // Статус кнопки
    public patient!: IPatient | null;
    public periodTest: string = '';
    public deviceType: string = '';
    //отловить сслыку
    public routerDynamicLink: string = '';
    public strFirst: string = '';
    public AccessStatement = false; // Доступ к стрпавке в налоговую
    public withFeedback: boolean = false;
    public pricelistExternalUrl: string = '';
    public isWorkPersonalData = true;
    public withFamilyAccess: boolean = false;
    public isMainAccount: boolean = true;
    public patientName: string = '';
    private _displayFullName: boolean = true;
    private resizeListener: (() => void) | undefined;
    @ViewChild('btnDropDown', { static: false })
    public btnDropDown!: NgbDropdown;

    public constructor(
        private router: Router,
        private cookieService: CookieConsentService,
        private auth: AuthService,
        private patientService: PatientService,
        private httpService: HttpNewService,
        private dialog: MatDialog,
        public size: Size,
        private load: LoadService,
    ) {
        this.router.events
            .pipe(
                filter(
                    (event): event is NavigationEnd =>
                        event instanceof NavigationEnd,
                ),
                takeUntil(this.destroy$),
            )
            .subscribe((event: NavigationEnd) => {
                this.routerDynamicLink = event.url.split('#')[0];
            });
        this.isMainAccount = this.isFamilyAccount();
        this.deviceType = this.size.getDeviceType();

        if (
            load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.LOGIN
                .IS_ROLES_SYSTEM
        ) {
            const authConfigSetting = this.load.getAccessUserConfig;
            this.isWorkPersonalData = authConfigSetting.includes(
                'lk_access_patient_data',
            );
        }
        this.AccessStatement =
            !!load.configData?.CLIENT_SETTINGS.OTHER
                .IS_ACCESS_STATEMENT_ENABLED;

        if (
            load.configData?.CLIENT_SETTINGS.OTHER.FEEDBACK_SUBJECTS !== null &&
            load.configData?.CLIENT_SETTINGS.ENABLED_MODULES.includes(
                'feedback',
            )
        )
            this.withFeedback = true;

        this.withFamilyAccess =
            !!load.configData?.CLIENT_SETTINGS.OTHER.IS_FAMILY_ACCESS;

        this.pricelistExternalUrl =
            load.configData?.CLIENT_SETTINGS?.EXTERNAL_LINKS?.PRICELIST ?? '';
    }
    private destroy$ = new Subject<void>();
    public ngOnInit(): void {
        this.deviceType = this.size.getDeviceType();
        this._displayFullName = window.innerWidth >= 768;
        this.patientService.fetchPatientInfo().subscribe();
        this.patientService.patient$
            .pipe(
                filter((patient): patient is IPatient => !!patient),
                takeUntil(this.destroy$),
            )
            .subscribe({
                next: (patient) => {
                    this.patient = patient;
                    this.patientName = [
                        patient.lastName,
                        patient.firstName,
                        patient.secondName,
                    ]
                        .filter(
                            (part): part is string =>
                                !!part && typeof part === 'string',
                        ) // фильтруем только непустые строки
                        .join(' ');

                    this.patientNameChange.emit(this.patientName);
                    this.patientService.setPatientName(this.patientName);
                },
                error: (err) => {
                    console.error(
                        ' Ошибка в подписке на данные пациента:',
                        err,
                    );
                    this.patient = null;
                },
            });
        this.resizeListener = () => {
            this._displayFullName = window.innerWidth >= 768;
        };
        window.addEventListener('resize', this.resizeListener);
    }
    public ngOnDestroy(): void {
        if (this.resizeListener) {
            window.removeEventListener('resize', this.resizeListener);
        }

        this.destroy$.next();
        this.destroy$.complete();
    }

    public openChange(event: any) {
        this.btnDropUP = event;
    }
    public goHome() {
        this.router.navigate(['/home']);
    }
    public isFamilyAccount(): boolean {
        const parentCookieName = Store.getDataString('ParentCookieName');
        if (parentCookieName) {
            return false;
        }
        return true;
    }
    public async exitFamilyAccount() {
        try {
            const cookieId = Store.getDataString('ParentCookieName');
            // console.log(cookieId);
            await lastValueFrom(
                this.httpService.get<string>('/family/set/cookie', {
                    cookieId: cookieId,
                    isSetParentCookie: 'true',
                }),
            );
        } catch (e) {
            console.error(`Error exit family account: ${e}`);
        } finally {
            Store.deleteStoreNameKey('ParentCookieName');
            window.location.reload();
        }
    }

    public onExit() {
        this.auth.logout();
    }
    public get hasNoBorderRadius(): boolean {
        return (
            this.router.url.startsWith('/home/rec') ||
            this.router.url.startsWith('/home/record-services') ||
            this.router.url.startsWith('/home/history')
        );
    }

    public showStatement() {
        if (this.AccessStatement) {
            // Закрываем dropdown
            this.btnDropDown?.close?.();

            // Откладываем открытие модалки на следующий тик (macrotask)
            setTimeout(() => {
                const dialogRef = this.dialog.open(StatementComponent, {
                    width: window.innerWidth <= 500 ? '100%' : 'auto',
                    minWidth: window.innerWidth <= 500 ? '100vw' : 'none',
                    height: window.innerWidth <= 500 ? '100%' : 'auto',
                    closeOnNavigation: true,
                    data: {},
                });

                dialogRef.afterClosed().subscribe(() => {});
            }, 0);
        }
    }

    public goFeedback() {
        if (window.innerWidth <= 767) {
            const dialogRef = this.dialog.open(FeedbackModalComponent, {
                width: '100%',
                minWidth: '100vw',
                height: '100%',
                closeOnNavigation: true,
                data: {},
                autoFocus: false,
                disableClose: true, // Add this to prevent default closing
            });

            // Handle backdrop click
            dialogRef.backdropClick().subscribe(() => {
                // The feedback component will handle its own closing logic
            });

            dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    // Handle result if needed
                }
            });
        } else {
            const dialogRef = this.dialog.open(FeedbackModalComponent, {
                maxWidth: '100vw',
                closeOnNavigation: true,
                data: {},
                autoFocus: false,
                disableClose: true, // Add this to prevent default closing
            });

            // Handle backdrop click
            dialogRef.backdropClick().subscribe(() => {
                // The feedback component will handle its own closing logic
            });

            dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    // Handle result if needed
                }
            });
        }
    }
    public showFamilyList() {
        if (this.withFamilyAccess) {
            if (window.innerWidth <= 500) {
                const dialogRef = this.dialog.open(FamilyAccessComponent, {
                    width: '100%',
                    minWidth: '100vw',
                    height: '100%',
                    closeOnNavigation: true,
                    data: {},
                });
                dialogRef.afterClosed().subscribe((result) => {
                    if (result) {
                        // Отмена номерка
                    }
                });
            } else {
                const dialogRef = this.dialog.open(FamilyAccessComponent, {
                    maxWidth: '100vw',
                    closeOnNavigation: true,
                    data: {},
                });
                dialogRef.afterClosed().subscribe((result) => {
                    if (result) {
                        // Отмена номерка
                    }
                });
            }
        }
    }

    public showPricelist() {
        if (this.pricelistExternalUrl) {
            window.open(this.pricelistExternalUrl, '_blank');
        }
    }

    public getPatientName() {
        return this._displayFullName
            ? this.patient?.firstName
            : this.patient?.firstName?.charAt(0);
    }
}
